import React, { useEffect, useState, useContext } from "react";
import {
  MdAirlineSeatReclineExtra,
  MdAir,
  MdElectricCar,
  MdBatteryFull,
  MdWorkspacePremium,
} from "react-icons/md";
import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";
import "./VoyahDreamExtras.css";

const CARD_ICONS = [
  MdAirlineSeatReclineExtra,
  MdAir,
  MdElectricCar,
  MdBatteryFull,
];

const VoyahDreamExtras = () => {
  const { currentLang } = useContext(LanguageContext);

  const [extras, setExtras] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadExtras = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("voyahdream", currentLang);
        setExtras(response.sections?.extras || null);
      } catch (err) {
        console.error("Failed to load Voyah Dream extras", err);
      } finally {
        setLoading(false);
      }
    };

    loadExtras();
  }, [currentLang]);

  if (loading || !extras) return null;

  const cards = [1, 2, 3, 4]
    .map((n) => ({
      title: extras[`feature_${n}_title`],
      description: extras[`feature_${n}_description`],
    }))
    .filter((card) => card.title || card.description);

  return (
    <section className="vd-extras">
      <div className="vd-container">
        <div className="vd-header">
          {extras.title ? <h2 className="vd-title">{extras.title}</h2> : null}
          {extras.subtitle ? (
            <p className="vd-subtitle">{extras.subtitle}</p>
          ) : null}
        </div>

        <div className="vd-grid">
          {cards.map((card, index) => {
            const Icon = CARD_ICONS[index];

            return (
              <div key={index} className="vd-card">
                <Icon className="vd-icon" />
                {card.title ? <h3>{card.title}</h3> : null}
                {card.description ? <p>{card.description}</p> : null}
              </div>
            );
          })}
        </div>

        {extras.positioning_line ? (
          <div className="vd-positioning">
            <MdWorkspacePremium className="vd-position-icon" />
            <span>{extras.positioning_line}</span>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default VoyahDreamExtras;
